// The comment recorded on a ticket when the requester accepts a catalog or AI answer: a "Deflected answer:"
// heading line, a blank line, then the answer. The blank line lets an answer that opens with a heading, list or
// code block start as one. The backend writes the same text for email and Teams in DeflectedAnswerComment.cs;
// change both together.
export const deflectedAnswerComment = (answer: string): string => `Deflected answer:\n\n${answer}`;
